import { useState, useEffect } from 'react';
import { getHarvestingBotsCount } from 'wisestep-api';

interface IBotsCount {
  allBotsCount: number;
  myBotsCount: number;
}

const useHarvestingBotsCount = () => {
  const [harvestBotsCount, setHarvestBotsCount] = useState<IBotsCount>();
  useEffect(() => {
    const getHarvestBotEvent = async () => {
      const response = await getHarvestingBotsCount();
      setHarvestBotsCount({
        allBotsCount: response.data.allBotsCount ?? 0,
        myBotsCount: response.data.myBotsCount ?? 0,
      });
    };
    getHarvestBotEvent();
  }, []);
  return harvestBotsCount;
};

export default useHarvestingBotsCount;
